const regSchemaVersion = new RegExp('(?:/pluginGenericSchema/v)+(?:([0-9]+)(?:(?:.)([0-9]+))?(?:(?:.)([0-9]+))?)');

function getVersion(major = 1, minor = 0, patch = 0) {
  return ({
    major,
    minor,
    patch,
  });
}

export function getSchemaVersion(schema) {
  if (!schema) {
    // eslint-disable-next-line no-console
    console.error(`invalid Schema version data ${schema}, using default.`);
    return getVersion();
  }

  /* Currect V1 schema version is schema or $schema is not set */
  if (typeof schema?.$schema === 'undefined') {
    return getVersion();
  }

  /* Regular expression to get schema version from schema data
      Supported version formats:
      - /pluginGenericSchema/v{number}
      - /pluginGenericSchema/v{number}.{number}
      - /pluginGenericSchema/v{number}.{number}.{number}
  */
  const regExData = regSchemaVersion.exec(schema?.$schema);

  if (Array.isArray(regExData) && regExData.length > 0) {
    const major = parseInt(regExData[1], 10) || 1;
    const minor = parseInt(regExData[2], 10) || 0;
    const patch = parseInt(regExData[3], 10) || 0;

    return getVersion(major, minor, patch);
  }
  // eslint-disable-next-line no-console
  console.error(`invalid Schema version data ${schema?.$schema}, using default.`);
  return getVersion();
}
